<div class="rounded-xl border border-slate-200 bg-white shadow-sm">
    <!-- Header with accent line -->
    <div
        class="relative flex items-center justify-between overflow-hidden rounded-t-xl border-b border-slate-100 px-5 py-4"
    >
        <!-- Vertical accent line -->
        <div
            class="absolute bottom-0 top-0 w-1 bg-primary-500 ltr:left-0 rtl:right-0"
        ></div>

        <!-- Title -->
        <h3 class="font-semibold text-slate-800 ltr:pl-3 rtl:pr-3">
            {{ contentTitle || '&#8203;' }}
        </h3>

        <!-- Tools -->
        <div class="flex items-center gap-2">
            <ng-content select="[tools]"></ng-content>
        </div>
    </div>

    <!-- Content -->
    <div [class.p-5]="!noPadding">
        <ng-content select="[content]"></ng-content>
    </div>
</div>
